export default "__VITE_ASSET__5807d41c__"